// extracted by mini-css-extract-plugin
export var black = "style-module--black--Ks2Xu";
export var darkgreen = "style-module--darkgreen--y4cJD";
export var fontsLoading = "style-module--fonts-loading--BCjSO";
export var h2 = "style-module--h2--OIbAJ";
export var h3 = "style-module--h3--7YY9L";
export var imgCenter = "style-module--imgCenter--rfaOh";
export var imgLeft = "style-module--imgLeft--HUtE3";
export var imgRight = "style-module--imgRight--vSuEn";
export var imgTitle = "style-module--imgTitle--kwGQk";
export var link = "style-module--link--NYbpL";
export var normalBold = "style-module--normalBold--KjP2K";
export var orange = "style-module--orange--iwCCv";
export var pink = "style-module--pink--HbzMT";
export var reachCustomImg100 = "style-module--reachCustomImg100--RN9MQ";
export var reachCustomImg30 = "style-module--reachCustomImg30--whumF";
export var reachCustomImg50 = "style-module--reachCustomImg50--xkuy+";
export var reachCustomImg75 = "style-module--reachCustomImg75--1z-Zt";
export var richTextLink = "style-module--richTextLink--mqsY5";
export var skyblue = "style-module--skyblue--Ql1mo";
export var textStyle = "style-module--textStyle--X-rF6";